import React, { useState, useEffect, useCallback } from "react";
import { chatApi } from "./chatbotApi";

// Modal di gestione membri di una conversazione (solo il proprietario della chat).
// Aggiunge/rimuove utenti con accesso al Chatbot che potranno vedere E usare la chat.
const MembersModal = ({ conversationId, onClose, onChanged }) => {
    const [members, setMembers] = useState([]);
    const [invitable, setInvitable] = useState([]);
    const [selected, setSelected] = useState("");
    const [loading, setLoading] = useState(true);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const load = useCallback(() => {
        setLoading(true);
        Promise.all([chatApi.listMembers(conversationId), chatApi.listInvitableUsers(conversationId)])
            .then(([m, inv]) => {
                setMembers(m);
                setInvitable(inv);
                setSelected(inv.length > 0 ? String(inv[0].id) : "");
            })
            .catch((e) => setError(e.response?.data?.error || "Impossibile caricare i membri."))
            .finally(() => setLoading(false));
    }, [conversationId]);

    useEffect(() => {
        load();
    }, [load]);

    const add = async () => {
        if (!selected) return;
        setBusy(true);
        setError("");
        try {
            await chatApi.inviteMember(conversationId, Number(selected));
            load();
            if (onChanged) onChanged();
        } catch (e) {
            setError(e.response?.data?.error || "Errore aggiunta membro.");
        } finally {
            setBusy(false);
        }
    };

    const remove = async (userId) => {
        setBusy(true);
        setError("");
        try {
            await chatApi.removeMember(conversationId, userId);
            load();
            if (onChanged) onChanged();
        } catch (e) {
            setError(e.response?.data?.error || "Errore rimozione membro.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="chatbot-modal-overlay" onClick={onClose}>
            <div className="chatbot-modal" onClick={(e) => e.stopPropagation()}>
                <h3>Membri della conversazione</h3>
                <p>Aggiungi utenti con accesso al Chatbot: potranno vedere e usare questa chat.</p>
                {error && <div className="chatbot-error">{error}</div>}

                {loading ? (
                    <p>Caricamento…</p>
                ) : (
                    <>
                        <div className="chatbot-share-row">
                            <select
                                value={selected}
                                onChange={(e) => setSelected(e.target.value)}
                                disabled={invitable.length === 0}
                            >
                                {invitable.length === 0 && <option value="">Nessun utente disponibile</option>}
                                {invitable.map((u) => (
                                    <option key={u.id} value={u.id}>
                                        {u.username}
                                    </option>
                                ))}
                            </select>
                            <button onClick={add} disabled={busy || !selected}>
                                Aggiungi
                            </button>
                        </div>

                        <div className="chatbot-member-list">
                            {members.length === 0 && (
                                <p className="chatbot-empty-hint">
                                    Nessun membro: solo tu (proprietario) hai accesso.
                                </p>
                            )}
                            {members.map((m) => (
                                <div key={m.user_id} className="chatbot-member-row">
                                    <span>{m.username}</span>
                                    <button
                                        className="chatbot-conv-del"
                                        title="Rimuovi"
                                        disabled={busy}
                                        onClick={() => remove(m.user_id)}
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                <div className="chatbot-modal-actions">
                    <button onClick={onClose}>Chiudi</button>
                </div>
            </div>
        </div>
    );
};

export default MembersModal;
